// extracted by mini-css-extract-plugin
module.exports = {"newscontent-box":"cW","newscontentBox":"cW"};